<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex xs12 md12>

  <material-card
              :title="'The following action is an irreversible process. It will delete all of the bacbon-school users\' notifications within the selected date-range. So act wisely.'"
              color="red"> 
               <v-layout wrap>
    
          <v-flex class="md5 pt-4">
              <date-picker placeholder="Search by date (range)" range v-model="date"></date-picker>
          </v-flex>
          <v-flex class="md4 pt-2">
               <v-btn
                class="mx-0 font-weight-light" v-if="date"
                color="danger" @click="deleteMessageDialog">Delete</v-btn>
               <v-btn v-if="date"
                class="mx-0 font-weight-light"  style="margin-left:5px !important"
                color="warning" @click="onClearButtonClick">Clear</v-btn>
          </v-flex>
        </v-layout>
            </material-card>


 

        <v-snackbar
          :color="color"
          :bottom="bottom"
          :top="top"
          :left="left"
          :right="right"
          v-model="snackbar"
          dark
        >
          <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
          <div>{{ noticeMessage }}</div>
          <v-icon size="16" @click="snackbar = false">
            mdi-close-circle
          </v-icon>
        </v-snackbar>
      </v-flex>
    </v-layout>

         <v-dialog v-model="dialogDeleteMessage" width="1000" hegiht="auto" persistent>
          <template v-slot:activator="{ on }">
            
      
          </template>

          <v-card>
            
          <v-container>
            <material-card
              :title="'Delete'"
              color="red"> 
            <v-flex
              xs12>
              You are going to delete Messages
              <h3>
                Are you sure!!
              </h3>
            </v-flex>
            </material-card>
            <v-flex
              xs12
              text-xs-right>
              <v-btn @click="deleteMessage"
                class="mx-0 font-weight-light"
                color="success" >Yes</v-btn>
              <v-btn @click="closeDeleteDialog"
                class="mx-2 font-weight-light"
                color="info">No</v-btn>
                
            </v-flex> 
          </v-container>
          </v-card>
        </v-dialog>

  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import Form from "@/views/Form";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
  components: {
    DatePicker,
    Form
  },
  computed: {   
    ...mapState('sendUserMessage', []),
  },
  mounted() {
   // this.getPaymentList();
  },
  data() {
    return {
      date: null,
      valid: true,
      userPayment: {},
      makePayment: {},
      searchTermStudent: "",
      isSearchStudent :false,
      foundStudent: {},
      color: null,
      searchTerm: "",
      colors: ["warning"],
      top: true,
      bottom: false,
      left: false,
      right: false,
      snackbar: false, 
      dialogDeleteMessage: false,
      noticeMessage: "",
      valueObj: {},
    };
  },
  created() {},
  methods: {
     ...mapActions("sendUserMessage", [ "deleteMessageByDate"]),
 
  onClearButtonClick (event) {  
      this.date = null;
    },


  deleteMessageDialog () {     
      this.dialogDeleteMessage = true
    },
  closeDeleteDialog () {
  this.dialogDeleteMessage = false
  this.date = null;
  },

  deleteMessage() {
    let from_date = null;
    let to_date = null;
    if(this.date){
      from_date = this.date[0] ? this.date[0] : null;
       to_date = this.date[1] ? this.date[1] : null;
    }
       

      let obj = {      
        from: from_date,
        to: to_date
      };

      let loader = this.$loading.show({
          color: "green",
          canCancel: false,
          onCancel: this.onCancel,
          loader: 'dots',
          isFullPage: true
        });

      this.deleteMessageByDate(obj).then(response => {
        console.log(response)
         loader.hide()
        if (response.status == "OK") {       
         
          this.color = "success";        
          this.noticeMessage = "Success! " + response.messages;
          this.snack("top");
          this.messageData = {};
           this.date = null;
          this.dialogDeleteMessage = false
        } else {
          this.color = "warning";
          this.noticeMessage = "Warning! " + response.messages;
          this.snack("top");
        }
      
      }).catch(err => {
          console.log(err);
           loader.hide()
        });
    },


    snack(...args) {
      this.top = false;
      this.bottom = false;
      this.left = false;
      this.right = false;

      for (const loc of args) {
        this[loc] = true;
      }

      this.snackbar = true;
    },
  },
};
</script>
